import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { RanklistPageComponent } from './ranklist/ranklist-page.component';
import { RoomChampionsPageComponent } from './roomchampions/roomchampions-page.component';
import { BranchChampionsPageComponent } from './branchchampions/branchchampions-page.component';
import { LastplayersPagesComponent } from './lastplayers/lastplayers-pages.component';
import { ChampionTvPageComponent } from './championtv/championtv-page.component';
import { ResponsiveranklistPageComponent } from './responsiveranklist/responsiveranklist-page.component';
import { ResponsiveRoomChampionsPageComponent } from './responsiveroomchampions/responsiveroomchampions-page.component';

const routes: Routes = [
  {
    path: 'ranklist',
    component: RanklistPageComponent,
  },
  {
    path: 'roomchampions/:nameSpace/:id',
    component: RoomChampionsPageComponent,
  },
  {
    path: 'championlist/:nameSpace',
    component: BranchChampionsPageComponent,
  },
  {
    path: 'lastplayers/:nameSpace/:id',
    component: LastplayersPagesComponent,
  },
  {
    path: 'championlisttv/:nameSpace',
    component: ChampionTvPageComponent,
  },
  {
    path: 'responsiveranklist',
    component: ResponsiveranklistPageComponent,
  },
  {
    path: 'responsiveroomchampions/:nameSpace/:id',
    component: ResponsiveRoomChampionsPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
  private apiUrl = environment.rootApiUrl;
}
